import { render, staticRenderFns } from "./CkEditor.vue?vue&type=template&id=6e6748ba"
import script from "./CkEditor.vue?vue&type=script&lang=ts"
export * from "./CkEditor.vue?vue&type=script&lang=ts"
import style0 from "./CkEditor.vue?vue&type=style&index=0&id=6e6748ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports